(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aroma-secimi"] && !Shopify.designMode) return;
  try {
    class AromaSecimi extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.arrows = Array.from(this.querySelectorAll('.aroma__arrow'));
      this.arrows.forEach((btn) => {
        btn.addEventListener('click', () => {
          const step = this.track.clientWidth * 0.8 * Number(btn.dataset.dir);
          this.track.scrollBy({ left: step, behavior: 'smooth' });
        });
      });

      this.track.addEventListener('scroll', () => this.syncArrows(), { passive: true });
      this.syncArrows();
      this.centerCurrent();

      if (this.dataset.keepPosition === 'true') {
        this.restorePosition();
        this.rememberPosition();
      }
    }

    // Tıklamadan önce bloğun ekrandaki yerini sakla
    rememberPosition() {
      this.querySelectorAll('.aroma-card').forEach((card) => {
        card.addEventListener('click', () => {
          try {
            sessionStorage.setItem('aromaViewportTop', String(this.getBoundingClientRect().top));
          } catch (e) {
            /* özel sekmede depolama kapalı olabilir */
          }
        });
      });
    }

    // Yeni sayfada bloğu tam olarak aynı noktaya oturt — zıplama olmaz
    restorePosition() {
      let saved = null;
      try {
        saved = sessionStorage.getItem('aromaViewportTop');
        sessionStorage.removeItem('aromaViewportTop');
      } catch (e) {
        return;
      }
      if (saved === null) return;

      const apply = () => {
        const target = window.scrollY + this.getBoundingClientRect().top - Number(saved);
        window.scrollTo({ top: Math.max(0, target), behavior: 'instant' });
      };

      apply();
      requestAnimationFrame(apply);
    }

    // Bulunduğun çeşidi, sayfayı kaydırmadan karuselin ortasına al
    centerCurrent() {
      const current = this.track.querySelector('[data-current="true"]');
      if (!current) return;
      const behavior = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft =
        current.offsetLeft - (this.track.clientWidth - current.clientWidth) / 2;
      this.track.style.scrollBehavior = behavior;
      requestAnimationFrame(() => this.syncArrows());
    }

    syncArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      this.arrows.forEach((btn) => {
        const dir = Number(btn.dataset.dir);
        btn.disabled = dir < 0 ? this.track.scrollLeft <= 0 : this.track.scrollLeft >= max;
      });
    }
  }

  if (!customElements.get('aroma-secimi')) {
    customElements.define('aroma-secimi', AromaSecimi);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dh-paket-icerik"] && !Shopify.designMode) return;
  try {
    class DhPaketIcerik extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      this.onVariant = this.onVariant.bind(this);
      this.section?.addEventListener('variant:update', this.onVariant);
      try { this.sayilar = JSON.parse(this.querySelector('[data-sayilar]').textContent); } catch (e) { this.sayilar = {}; }
      this.querySelectorAll('.dh-pi__gecis').forEach((b) => {
        b.addEventListener('click', () => {
          const secici = this.section?.querySelector('gramaj-secici');
          if (secici && typeof secici.select === 'function') {
            secici.select(b.dataset.hedef);
            this.goster(b.dataset.hedef);
          }
        });
      });
    }
    disconnectedCallback() {
      this.section?.removeEventListener('variant:update', this.onVariant);
    }
    onVariant(event) {
      const id = event?.detail?.resource?.id;
      if (id) this.goster(String(id));
    }
    goster(id) {
      const n = this.sayilar[id];
      if (!n) return;
      this.querySelectorAll('.dh-pi__oge').forEach((o) => {
        o.toggleAttribute('data-disarida', Number(o.dataset.sira) > n);
      });
      this.querySelectorAll('.dh-pi__gecis').forEach((b) => {
        b.hidden = b.dataset.kaynak !== id;
      });
      this.querySelectorAll('[data-dh-pi-hediye]').forEach((h) => { h.hidden = n < 6; });
    }
  }
  if (!customElements.get('dh-paket-icerik')) {
    customElements.define('dh-paket-icerik', DhPaketIcerik);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dh-secim-ozeti"] && !Shopify.designMode) return;
  try {
    class DhSecimOzeti extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      this.onVariant = this.onVariant.bind(this);
      this.section?.addEventListener('variant:update', this.onVariant);
    }
    disconnectedCallback() {
      this.section?.removeEventListener('variant:update', this.onVariant);
    }
    onVariant(event) {
      const id = event?.detail?.resource?.id;
      if (id) this.goster(String(id));
    }
    goster(id) {
      const kartlar = [...this.querySelectorAll('[data-variant-id]')];
      if (!kartlar.some((k) => k.dataset.variantId === id)) return;
      for (const k of kartlar) k.hidden = k.dataset.variantId !== id;
      this.dataset.selected = id;
    }
  }
  if (!customElements.get('dh-secim-ozeti')) {
    customElements.define('dh-secim-ozeti', DhSecimOzeti);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gramaj-secici"] && !Shopify.designMode) return;
  try {
    class GramajSecici extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('.gramaj-row'));
      if (!this.rows.length) return;

      this.picker = document.querySelector('variant-picker[ref="mainVariantPicker"]');

      if (this.dataset.hideNative === 'true' && this.picker) {
        document.documentElement.classList.add('gramaj-native-hidden');
      }

      this.rows.forEach((row) => {
        row.addEventListener('click', () => this.select(row.dataset.variantId));
      });

      if (this.picker) {
        this.picker.addEventListener('change', () => this.syncFromPicker());
      }

      this.syncFromPicker();
    }

    nativeInput(variantId) {
      if (!this.picker) return null;
      return this.picker.querySelector('input[data-variant-id="' + variantId + '"]');
    }

    // Seçimi temanın kendi input'una devret — fiyat/stok/sepet onun işi
    select(variantId) {
      const input = this.nativeInput(variantId);
      if (!input) return;
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.mark(variantId);
    }

    syncFromPicker() {
      if (!this.picker) return;
      const checked = this.picker.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      this.mark(checked.dataset.variantId);
    }

    mark(variantId) {
      this.rows.forEach((row) => {
        const on = row.dataset.variantId === variantId;
        row.classList.toggle('gramaj-row--on', on);
        row.setAttribute('aria-checked', String(on));
      });
      this.querySelectorAll('[data-dilim-varyant]').forEach((satir) => {
        satir.hidden = satir.dataset.dilimVaryant !== String(variantId);
      });
    }
  }

  if (!customElements.get('gramaj-secici')) {
    customElements.define('gramaj-secici', GramajSecici);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hikaye-videolari"] && !Shopify.designMode) return;
  try {
    class HikayeVideolari extends HTMLElement {
    connectedCallback() {
      this.frames = Array.from(this.querySelectorAll('[data-frame]'));
      this.frames.forEach((frame) => {
        const video = frame.querySelector('video');
        const btn = frame.querySelector('[data-sound]');
        if (!video) return;
        video.muted = true;
        video.setAttribute('playsinline', '');
        if (btn) {
          btn.addEventListener('click', () => {
            const on = video.muted;
            // Ses tek videoda açık kalır
            this.frames.forEach((f) => {
              const v = f.querySelector('video');
              const b = f.querySelector('[data-sound]');
              if (v && v !== video) { v.muted = true; }
              if (b && b !== btn) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Sesi aç'); }
            });
            video.muted = !on;
            btn.setAttribute('aria-pressed', String(on));
            btn.setAttribute('aria-label', on ? 'Sesi kapat' : 'Sesi aç');
            if (video.paused) video.play().catch(() => {});
          });
        }
      });

      if (!('IntersectionObserver' in window)) {
        this.frames.forEach((f) => { const v = f.querySelector('video'); if (v) v.play().catch(() => {}); });
        return;
      }

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const v = e.target.querySelector('video');
          if (!v) return;
          if (e.intersectionRatio >= 0.5) v.play().catch(() => {});
          else v.pause();
        });
      }, { threshold: [0, 0.5, 1] });
      this.frames.forEach((f) => io.observe(f));
    }
  }

  if (!customElements.get('hikaye-videolari')) {
    customElements.define('hikaye-videolari', HikayeVideolari);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["icindekiler"] && !Shopify.designMode) return;
  try {
    class IcindekilerSerit extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('dialog');
      this.opener = this.querySelector('[data-open]');
      if (!this.modal || !this.opener) return;

      this.opener.addEventListener('click', () => {
        this.modal.showModal();
        document.documentElement.classList.add('icd-lock');
      });

      // Esc, dışarı tıklama ve kapat düğmesi — hepsi buradan geçer
      this.modal.addEventListener('close', () => {
        document.documentElement.classList.remove('icd-lock');
      });

      this.querySelectorAll('[data-close]').forEach((btn) => {
        btn.addEventListener('click', () => this.modal.close());
      });

      // Kutunun dışına tıklayınca kapansın
      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) this.modal.close();
      });
    }
  }

  if (!customElements.get('icindekiler-serit')) {
    customElements.define('icindekiler-serit', IcindekilerSerit);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ikramlik-cesit-secici"] && !Shopify.designMode) return;
  try {
    class IkramlikCesitSecici extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      this.onClick = this.onClick.bind(this);
      this.onVariant = this.onVariant.bind(this);
      this.addEventListener('click', this.onClick);
      this.section?.addEventListener('variant:update', this.onVariant);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.section?.removeEventListener('variant:update', this.onVariant);
    }
    onClick(event) {
      const kart = event.target.closest('.cesit__kart');
      if (!kart || !this.contains(kart)) return;
      const deger = kart.dataset.value;
      const radyo = this.section?.querySelector(
        `variant-picker input[type="radio"][value="${CSS.escape(deger)}"]`
      );
      if (radyo) {
        if (!radyo.checked) radyo.click();
      } else {
        // Açılır liste görünümü: seçeneği seçip change yay
        const secim = this.section?.querySelector('variant-picker select');
        if (secim) {
          secim.value = deger;
          secim.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      this.isaretle(kart.dataset.variantId);
    }
    onVariant(event) {
      const id = event?.detail?.resource?.id;
      if (id) this.isaretle(String(id));
    }
    isaretle(id) {
      const adAlani = this.querySelector('[data-secili-ad]');
      for (const kart of this.querySelectorAll('.cesit__kart')) {
        const secili = kart.dataset.variantId === id;
        kart.setAttribute('aria-pressed', secili ? 'true' : 'false');
        if (secili && adAlani) adAlani.textContent = kart.dataset.ad || '';
      }
      this.dataset.selected = id;
    }
  }
  if (!customElements.get('ikramlik-cesit-secici')) {
    customElements.define('ikramlik-cesit-secici', IkramlikCesitSecici);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ikramlik-icindekiler"] && !Shopify.designMode) return;
  try {
    class IkramlikIcindekiler extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      this.onVariant = this.onVariant.bind(this);
      this.section?.addEventListener('variant:update', this.onVariant);
    }
    disconnectedCallback() {
      this.section?.removeEventListener('variant:update', this.onVariant);
    }
    onVariant(event) {
      const id = event?.detail?.resource?.id;
      if (!id) return;
      let bulundu = false;
      for (const p of this.querySelectorAll('.icr__panel')) {
        const esles = p.dataset.variantId === String(id);
        p.hidden = !esles;
        if (esles) bulundu = true;
      }
      if (bulundu) this.dataset.selected = String(id);
      else for (const p of this.querySelectorAll('.icr__panel')) p.hidden = p.dataset.variantId !== this.dataset.selected;
    }
  }
  if (!customElements.get('ikramlik-icindekiler')) {
    customElements.define('ikramlik-icindekiler', IkramlikIcindekiler);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ikramlik-teklif-karti"] && !Shopify.designMode) return;
  try {
    class IkramlikTeklif extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      this.onVariant = this.onVariant.bind(this);
      this.section?.addEventListener('variant:update', this.onVariant);
      this.baslat();
    }
    disconnectedCallback() {
      this.section?.removeEventListener('variant:update', this.onVariant);
      clearInterval(this.zaman);
    }
    onVariant(event) {
      const id = event?.detail?.resource?.id;
      if (id) this.goster(String(id));
    }
    goster(id) {
      let bulundu = false;
      for (const el of this.querySelectorAll('[data-variant-id]')) {
        const esles = el.dataset.variantId === id;
        el.hidden = !esles;
        if (esles) bulundu = true;
      }
      if (!bulundu) this.goster(this.dataset.selected);
      else this.dataset.selected = id;
    }
    baslat() {
      if (!this.dataset.end) return;
      this.bitis = new Date(this.dataset.end).getTime();
      if (Number.isNaN(this.bitis)) return;
      this.tik = this.tik.bind(this);
      this.tik();
      this.zaman = setInterval(this.tik, 30000);
    }
    tik() {
      const kalan = this.bitis - Date.now();
      if (kalan <= 0) {
        clearInterval(this.zaman);
        this.classList.add('tk--bitti');
        const on = this.querySelector('.tk__sayac-on');
        if (on) on.textContent = this.dataset.expired || 'Lansman teklifi sona erdi.';
        return;
      }
      const dk = Math.floor(kalan / 60000);
      this.querySelector('[data-gun]').textContent = Math.floor(dk / 1440);
      this.querySelector('[data-saat]').textContent = Math.floor((dk % 1440) / 60);
      this.querySelector('[data-dk]').textContent = dk % 60;
    }
  }
  if (!customElements.get('ikramlik-teklif')) {
    customElements.define('ikramlik-teklif', IkramlikTeklif);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kargo-takvimi"] && !Shopify.designMode) return;
  try {
    class KargoTakvimi extends HTMLElement {
    connectedCallback() {
      this.aylar = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
      this.gunler = ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
      this.cutH = Number(this.dataset.cutoffHour) || 14;
      this.cutM = Number(this.dataset.cutoffMinute) || 0;
      this.sat = this.dataset.shipSaturday === 'true';
      this.dMin = Number(this.dataset.deliveryMin) || 2;
      this.dMax = Number(this.dataset.deliveryMax) || 3;
      // Kasım S2 (R3, 29 Eki): iş günü sayımı ve tatil listesi — ikisi de ayarla açılır,
      // kapalıyken eski davranış aynen sürer.
      this.isGunu = this.dataset.isGunu === 'true';
      this.tatil = new Set((this.dataset.tatiller || '').split(',').map((x) => x.trim()).filter((x) => /^\d{4}-\d{2}-\d{2}$/.test(x)));
      this.last = {};

      this.tick();
      // Hız (1 Kas): kart ekranda değilken sayaç saniyede bir sayfayı yormaz; ekrana girince hemen güncellenir.
      this.gorunur = true;
      this.timer = setInterval(() => { if (this.gorunur) this.tick(); }, 1000);
      if ('IntersectionObserver' in window) {
        this.gozcu = new IntersectionObserver((entries) => {
          const gorunur = entries.some((e) => e.isIntersecting);
          if (gorunur && !this.gorunur) { this.gorunur = true; this.tick(); }
          else this.gorunur = gorunur;
        });
        this.gozcu.observe(this);
      }

      const route = this.querySelector('[data-route]');
      if (route && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            route.classList.add('is-in');
            io.disconnect();
          }
        }, { threshold: 0.35 });
        io.observe(route);
      } else if (route) {
        route.classList.add('is-in');
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.gozcu) this.gozcu.disconnect();
    }

    // Türkiye saatiyle "şimdi" — müşteri nerede olursa olsun
    now() {
      const p = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Istanbul', hour12: false,
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
      }).formatToParts(new Date()).reduce((o, x) => (o[x.type] = x.value, o), {});
      return new Date(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second);
    }

    key(d) {
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }

    // Teslimat iş günü: Pazartesi–Cuma, tatil listesindeki günler hariç
    isWorkday(d) {
      const g = d.getDay();
      return g !== 0 && g !== 6 && !this.tatil.has(this.key(d));
    }

    addWorkdays(from, n) {
      const d = new Date(from);
      let kalan = n;
      while (kalan > 0) {
        d.setDate(d.getDate() + 1);
        if (this.isWorkday(d)) kalan -= 1;
      }
      return d;
    }

    shipsOn(d) {
      if (this.tatil.has(this.key(d))) return false;
      const g = d.getDay();
      if (g === 0) return false;
      if (g === 6) return this.sat;
      return true;
    }

    tick() {
      const now = this.now();
      const cut = new Date(now); cut.setHours(this.cutH, this.cutM, 0, 0);

      // Kargo günü: kesimden önceyse bugün, değilse sonraki gün; kargo çıkmayan günler atlanır
      const ship = new Date(now); ship.setHours(0, 0, 0, 0);
      if (now >= cut) ship.setDate(ship.getDate() + 1);
      while (!this.shipsOn(ship)) ship.setDate(ship.getDate() + 1);

      const target = new Date(ship); target.setHours(this.cutH, this.cutM, 0, 0);
      let kalan = Math.max(0, Math.floor((target - now) / 1000));
      const gun = Math.floor(kalan / 86400); kalan -= gun * 86400;
      const saat = Math.floor(kalan / 3600); kalan -= saat * 3600;
      const dk = Math.floor(kalan / 60);
      const sn = kalan % 60;

      this.setDigit('gun', gun, gun > 0);
      this.setDigit('saat', saat, true);
      this.setDigit('dk', dk, true);
      this.setDigit('sn', sn, true);

      const today = new Date(now); today.setHours(0, 0, 0, 0);
      const diff = Math.round((ship - today) / 86400000);
      const label = this.querySelector('[data-label]');
      if (label) {
        label.textContent = diff === 0 ? this.dataset.todayText || 'BUGÜN KARGODA'
          : diff === 1 ? this.dataset.tomorrowText || 'YARIN KARGODA'
          : this.gunler[ship.getDay()].toLocaleUpperCase('tr') + ' KARGODA';
      }
      this.dataset.urgent = String(diff === 0 && (target - now) < 3600000);

      // Teslim aralığı — iş günü sayımı açıksa kargodan sonra iş günü eklenir (hafta sonu ve
      // tatiller atlanır); kapalıysa eski hesap: takvim günü, Pazar'a düşerse ertesi güne
      let tMin, tMax;
      if (this.isGunu) {
        tMin = this.addWorkdays(ship, this.dMin);
        tMax = this.addWorkdays(ship, this.dMax);
      } else {
        tMin = new Date(ship); tMin.setDate(tMin.getDate() + this.dMin); if (tMin.getDay() === 0) tMin.setDate(tMin.getDate() + 1);
        tMax = new Date(ship); tMax.setDate(tMax.getDate() + this.dMax); if (tMax.getDay() === 0) tMax.setDate(tMax.getDate() + 1);
      }

      this.setDate('siparis', this.fmt(today));
      this.setDate('kargo', this.fmt(ship));
      // Aynı güne düşen aralık "2–2 Kasım" değil tek tarih yazılır
      this.setDate('teslim', tMin.getTime() === tMax.getTime() ? this.fmt(tMin) : tMin.getMonth() === tMax.getMonth()
        ? tMin.getDate() + '–' + tMax.getDate() + ' ' + this.aylar[tMax.getMonth()]
        : this.fmt(tMin) + ' – ' + this.fmt(tMax));
    }

    fmt(d) { return d.getDate() + ' ' + this.aylar[d.getMonth()]; }

    setDigit(unit, val, show) {
      const wrap = this.querySelector('[data-unit="' + unit + '"]');
      if (!wrap) return;
      wrap.hidden = !show;
      const b = wrap.querySelector('[data-val]');
      if (this.last[unit] === val) return;
      this.last[unit] = val;
      // Hız (1 Kas): metin düğümü yerinde değişir, animasyon zorla yeniden hesaplatmadan iki kare sonra başlar.
      // textContent + offsetWidth her saniye bütün sayfanın stilini yeniden hesaplatıyordu (~2.500 öğe).
      if (b.firstChild && b.firstChild.nodeType === 3) b.firstChild.nodeValue = String(val);
      else b.textContent = String(val);
      b.classList.remove('tick');
      requestAnimationFrame(() => requestAnimationFrame(() => b.classList.add('tick')));
    }

    setDate(key, text) {
      const el = this.querySelector('[data-date="' + key + '"]');
      if (el && el.textContent !== text) el.textContent = text;
    }
  }

  if (!customElements.get('kargo-takvimi')) {
    customElements.define('kargo-takvimi', KargoTakvimi);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lansman-sayac"] && !Shopify.designMode) return;
  try {
    class LansmanSayac extends HTMLElement {
    connectedCallback() {
      this.bitis = new Date(this.dataset.end).getTime();
      if (Number.isNaN(this.bitis)) { this.hidden = true; return; }
      this.tik = this.tik.bind(this);
      this.tik();
      this.zaman = setInterval(this.tik, 30000);
    }

    disconnectedCallback() { clearInterval(this.zaman); }

    tik() {
      const kalan = this.bitis - Date.now();
      if (kalan <= 0) {
        clearInterval(this.zaman);
        const mesaj = this.dataset.expired;
        if (!mesaj) { this.hidden = true; return; }
        this.classList.add('sayac--bitti');
        this.querySelector('.sayac__metin').textContent = mesaj;
        return;
      }
      const dk = Math.floor(kalan / 60000);
      const gun = Math.floor(dk / 1440);
      const saat = Math.floor((dk % 1440) / 60);
      this.querySelector('[data-gun]').textContent = gun;
      this.querySelector('[data-saat]').textContent = saat;
      this.querySelector('[data-dk]').textContent = dk % 60;
    }
  }

  if (!customElements.get('lansman-sayac')) {
    customElements.define('lansman-sayac', LansmanSayac);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["neden-galerisi"] && !Shopify.designMode) return;
  try {
    class NedenGalerisi extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.panels.forEach((panel) => {
        const hit = panel.querySelector('[data-hit]');
        if (!hit) return;
        hit.addEventListener('click', () => this.open(panel));
      });
    }

    open(target) {
      this.panels.forEach((panel) => {
        const on = panel === target;
        panel.classList.toggle('is-open', on);
        const hit = panel.querySelector('[data-hit]');
        if (hit) hit.setAttribute('aria-expanded', String(on));
      });
    }
  }

  if (!customElements.get('neden-galerisi')) {
    customElements.define('neden-galerisi', NedenGalerisi);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["teklif-kutusu"] && !Shopify.designMode) return;
  try {
    class TeklifKutusu extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      if (!this.section) return;
      this.onVariant = this.onVariant.bind(this);
      this.section.addEventListener('variant:update', this.onVariant);
    }

    disconnectedCallback() {
      this.section?.removeEventListener('variant:update', this.onVariant);
    }

    onVariant(event) {
      const id = event?.detail?.resource?.id;
      if (!id) return;
      this.goster(String(id));
    }

    goster(id) {
      let bulundu = false;
      for (const durum of this.querySelectorAll('.teklif__durum')) {
        const esles = durum.dataset.variantId === id;
        durum.hidden = !esles;
        if (esles) bulundu = true;
      }
      // Bilinmeyen varyant: hiçbir satır gizli kalmasın diye eski seçim geri gelir.
      if (!bulundu) this.goster(this.dataset.selected);
      else this.dataset.selected = id;
    }
  }

  if (!customElements.get('teklif-kutusu')) {
    customElements.define('teklif-kutusu', TeklifKutusu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["teklif-ozeti"] && !Shopify.designMode) return;
  try {
    class TeklifOzeti extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-tozet-git]')?.addEventListener('click', () => {
        const hedef = document.querySelector('variant-picker, .variant-picker, product-form, .buy-buttons-block');
        if (hedef) hedef.scrollIntoView({ behavior: 'smooth', block: 'center' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }
  if (!customElements.get('teklif-ozeti')) customElements.define('teklif-ozeti', TeklifOzeti);
  } catch(e) { console.error(e); }
})();

})();
